import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getGroups } from 'redux/actions/groupsActions';
import Header from 'components/layout/Partials/Header';
import { Helmet } from 'react-helmet';
import * as Icon from 'react-feather';
import { ToastsStore } from 'react-toasts';
import axios from 'axios';
import { Theme } from 'utils/Theme';
import { withStyles } from '@material-ui/styles';
import Loading from 'components/common/Loading';
import { Link } from 'react-router-dom';
import AdminLayout from 'components/layout/AdminLayout';
import DataTable from 'react-data-table-component';
import { isEmpty } from 'lodash';
import Section from 'components/UI/Section';
import { Box } from '@material-ui/core';
import GroupsTableActions from './TableActions/GroupsTableActions';

const styles = Theme();

class Groups extends Component {
    constructor(prop) {
        super(prop);
        this.state = {
            toDelete: null,
        };

        this.deleteGroup = this.deleteGroup.bind(this);
        this.columns = [
            {
                name: 'Title',
                selector: 'name',
                sortable: true,
            },
            {
                name: 'Description',
                selector: 'description',
                sortable: true,
            },
            {
                name: 'Actions',
                width: '350px',
                button: true,
                cell: ({ _id }) => (
                    <GroupsTableActions
                        id={_id}
                        handleDelete={() => this.setState({ toDelete: _id })}
                    />
                ),
                sortable: false,
            },
        ];
    }

    tableActions = (group) => (
        <div className={'u-text-right'}>
            <button
                className={`c-btn ${this.props.classes.buttonPrimary} u-m-xsmall c-btn--small has-arrow u-text-center`}
                onClick={() =>
                    this.props.history.push(
                        `/settings/groups/${group._id}/view`
                    )
                }
            >
                <Icon.Eye size={10} /> Manage
            </button>
            <button
                onClick={() =>
                    this.props.history.push(
                        `/settings/groups/${group._id}/edit`
                    )
                }
                className={`c-btn ${this.props.classes.buttonInfo} u-m-xsmall c-btn--small has-arrow u-text-center`}
            >
                <Icon.Edit3 size={10} /> Edit
            </button>

            <button
                type={'button'}
                onClick={() => this.setState({ toDelete: group._id })}
                className={`c-btn ${this.props.classes.buttonDanger} u-m-xsmall c-btn--small has-arrow u-text-center`}
            >
                <Icon.Slash size={10} /> Delete
            </button>
        </div>
    );

    deleteGroup(group_id) {
        this.setState({ toDelete: null });
        axios.delete(`/api/groups/delete/${group_id}`).then(() => {
            ToastsStore.success(
                'Group and all associated objects deleted successfully'
            );
            this.props.getGroups();
        });
    }

    componentDidMount() {
        this.props.getGroups();
    }

    render() {
        const { groups, classes } = this.props;
        const loading = groups.loading;
        const groupList = groups.groups;

        return (
            <AdminLayout>
                <Helmet>
                    <title>All Groups</title>
                </Helmet>
                <div className="o-group">
                    <Header>
                        <h2 className="c-navbar__title">Security Groups</h2>
                    </Header>
                    <div className="u-m-xsmall">
                        {loading && <Loading classes={classes} />}

                        {!loading && !isEmpty(groupList) && (
                            <Section>
                                <Box className={'full_height'}>
                                    <div className=" o-line u-p-medium">
                                        <h4
                                            className={`c-card__title ${classes.colorPrimary}`}
                                        >
                                            Site Security Groups
                                        </h4>
                                        <button
                                            onClick={() =>
                                                this.props.history.push(
                                                    '/settings/groups/create'
                                                )
                                            }
                                            className={`c-btn ${classes.buttonPrimary}`}
                                        >
                                            Create Group
                                        </button>
                                    </div>

                                    {!loading && !isEmpty(groupList) && (
                                        <div className="c-table-responsive@wide">
                                            {this.state.toDelete !== null && (
                                                <table className={'c-table'}>
                                                    <tbody>
                                                        <tr className="c-table__row">
                                                            <td
                                                                className="c-table__cell"
                                                                colSpan={2}
                                                            >
                                                                Deleting the
                                                                group will also
                                                                remove all
                                                                references of
                                                                the group in
                                                                Pages and Users.
                                                            </td>
                                                            <td
                                                                className={
                                                                    'c-table__cell'
                                                                }
                                                            >
                                                                <button
                                                                    type={
                                                                        'button'
                                                                    }
                                                                    onClick={() =>
                                                                        this.deleteGroup(
                                                                            this
                                                                                .state
                                                                                .toDelete
                                                                        )
                                                                    }
                                                                    className={`c-btn ${this.props.classes.buttonDanger} u-m-xsmall c-btn--small has-arrow u-text-center`}
                                                                >
                                                                    <Icon.Slash
                                                                        size={
                                                                            10
                                                                        }
                                                                    />{' '}
                                                                    Delete
                                                                </button>
                                                                <button
                                                                    type={
                                                                        'button'
                                                                    }
                                                                    onClick={() => {
                                                                        this.setState(
                                                                            {
                                                                                toDelete: null,
                                                                            }
                                                                        );
                                                                    }}
                                                                    className={`c-btn ${this.props.classes.buttonSecondary} u-m-xsmall c-btn--small has-arrow u-text-center`}
                                                                >
                                                                    <Icon.X
                                                                        size={
                                                                            12
                                                                        }
                                                                    />{' '}
                                                                    Cancel
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            )}
                                            {this.state.toDelete === null && (
                                                <DataTable
                                                    columns={this.columns}
                                                    data={groupList}
                                                    pagination={false}
                                                    noHeader={true}
                                                    keyField={'_id'}
                                                    className={'c-table'}
                                                />
                                            )}
                                        </div>
                                    )}
                                    {!loading && isEmpty(groupList) && (
                                        <div
                                            className={`c-alert ${classes.alertPrimary} alert`}
                                        >
                                            <h4 className="c-alert__title u-ml-small">
                                                <Icon.Info size={16} /> Nothing
                                                to show
                                            </h4>
                                            <div className="c-alert__content">
                                                <p>
                                                    There are no groups to show
                                                    please create new.
                                                </p>
                                                <div className="u-pt-medium">
                                                    {/*TODO : CHANGE LINK BELOW TO BACK BUTTON*/}
                                                    <Link
                                                        to={
                                                            '/settings/groups/create'
                                                        }
                                                        className={`c-btn ${classes.buttonPrimary} has-arrow u-text-center`}
                                                    >
                                                        {' '}
                                                        Create Group{' '}
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Box>
                            </Section>
                        )}
                    </div>
                </div>
            </AdminLayout>
        );
    }
}

Groups.propTypes = {
    auth: PropTypes.object.isRequired,
    getGroups: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    match: PropTypes.object,
    classes: PropTypes.object,
    history: PropTypes.object,
    groups: PropTypes.object,
};
const mapStateToProps = (state) => ({
    auth: state.auth,
    groups: state.groups,
    errors: state.errors,
});
export default connect(mapStateToProps, { getGroups })(
    withStyles(styles)(Groups)
);
